import type {Component, AsyncComponentLoader} from "vue";

import {defineAsyncComponent} from "vue";

export function customAsyncComponent(loader: AsyncComponentLoader): any {
  return defineAsyncComponent({
    loader: loader,
    delay: 200,
    timeout: 3000,
    suspensible: true,
    onError: async (error, retry, fail) => {
      fail()
    }
  })
}